export const QUICK_START_BUTTON = 'QUICK_START_BUTTON';
export const UNTACT_DEPARTMENT_LIST = 'UNTACT_DEPARTMENT_LIST';
export const UNTACT_DEPARTMENT_LIST_ITEM = 'UNTACT_DEPARTMENT_LIST_ITEM';
export const generateUntactDepartmentListItemFocusKey = (index: number) =>
  `${UNTACT_DEPARTMENT_LIST_ITEM}_${index}`;
export const UNTACT_DEPARTMENT_LIST_ITEM_FIRST =
  generateUntactDepartmentListItemFocusKey(0);
export const BANNER = 'BANNER';
